import {NgModule} from '@angular/core';
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {BrowserModule} from "@angular/platform-browser";
import {InsightsService} from "../../services/insights/insights.service";
import {InsightsComponent} from "./insights.component";
import {NpsModule} from "../../components/nps/nps.module";
import {PerformanceModule} from "../../components/performance/performance.module";
import { InsightsV2Module } from 'src/app/components/insights-v2/insights-v2/insights-v2.module';
import {ParticipationModule} from "../../components/participation/participation.module";
import {LeavingModule} from "../../components/leaving/leaving.module";
import { LoaderModule } from "../../components/loader/loader.module";
import {InsightsHelpModule} from "../../components/insights-help/insights-help.module";
import { FilterV2Module } from 'src/app/components/filter-v2/filter-v2.module';
import { FooterModule } from 'src/app/components/footer/footer.module';
import { InsightsSelectQuestionnaireModule } from 'src/app/components/insights-select-questionnaire/insights-select-questionnaire.module';
import { InsightsFilterModalModule } from 'src/app/components/insights-filter-modal/insights-filter-modal.module';
import {SendXrefButtonModule} from "../../components/send-xref-button/send-xref-button.module";
import {QuestionnaireService} from "../../services/questionnaire/questionnaire.service";
import {NgSelectModule} from "@ng-select/ng-select";
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DateRangeFilterModule } from 'src/app/lib/date-range-filter/date-range-filter.module';
import { DateRangePickerPopoverModule } from 'src/app/lib/date-range-picker-popover/date-range-picker-popover.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {ButtonModule, EmptyStateModule} from '@xref/xref-lib';
import {PulseParticipationModule} from "../../components/pulse-participation/pulse-participation.module";
import { PulseNpsModule } from 'src/app/components/pulse-nps/pulse-nps.module';
import { InsightsDepartmentPerformanceModule } from 'src/app/components/insights-department-performance/insights-department-performance/insights-department-performance.module';
import {HighchartsChartModule} from "highcharts-angular";
import {PulseCommentsComponentModule} from "../../components/pulse-comments/pulse-comments.module";
import { PulseAiSummaryModule } from 'src/app/components/pulse-ai-summary/pulse-ai-summary.module';


@NgModule({ declarations: [
        InsightsComponent,
    ], imports: [BrowserModule,
        FormsModule,
        NgSelectModule,
        NpsModule,
        PerformanceModule,
        InsightsDepartmentPerformanceModule,
        InsightsV2Module,
        ParticipationModule,
        PulseParticipationModule,
        LeavingModule,
        FooterModule,
        LoaderModule,
        InsightsHelpModule,
        InsightsSelectQuestionnaireModule,
        InsightsFilterModalModule,
        DateRangeFilterModule,
        DateRangePickerPopoverModule,
        FilterV2Module,
        SendXrefButtonModule,
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        ButtonModule,
        PulseNpsModule,
        HighchartsChartModule,
        EmptyStateModule,
        PulseCommentsComponentModule,
        PulseAiSummaryModule], providers: [
        InsightsService,
        QuestionnaireService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class InsightsModule {
}
